import { ConsumptionSite } from "@/data/model/Enums";
import type { IService } from "@/data/model/Service";

interface ISitePriceItem {
    price?: number;
    oohPrice?: number;
}

// an off site (take away) use case charges the article's out of house price whenever one is
// configured. the service is passed in instead of read from a global, because the app and the
// operator keep the current one in different places - the offer store is what they share
export function getSitePrice(item: ISitePriceItem, service: IService | undefined | null): number {
    const site = service?.useCase?.consumptionSite ?? ConsumptionSite.OnSite;

    if (site === ConsumptionSite.OffSite && item.oohPrice !== undefined) {
        return item.oohPrice;
    }

    return item.price ?? 0;
}
